import request from "@/axios.js";

export default class DFS {

	constructor(ps) {
	}
    /**
     * Get list of keywords for a domain
     * @param {String} domain 
     * @param {Number} location_code 
     * @returns 
     */
	static getKeywordsForDomain(body){
		return new Promise((resolve, reject) => {
			request.get(
				`/dataforseo/getKeywordsForDomain?domain=${body.domain}&location_code=${body.location_code}&language_name=${body.language_name}`
			)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		}	);

	}
	/**
	 * Get the number of crossover urls for a keywords
	 * @param {Array} keywords
	 * @param {Number} locationCode 
	 * @param {String} languageCode - fr/en/...
	 * @returns 
	 */
	static getCrossoverUrlsForKeywords(keywords, locationCode, languageCode){
		return new Promise((resolve, reject) => {
			request.post(
				`/dataforseo/keywords/cossoverUrls`,
				{
					"language_code": languageCode,
					"location_code": locationCode,
					// "urls" : urls,
					"keywords": keywords
				}

			)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		}	);

	}
	
}
